import $3fe4y$react, {useContext as $3fe4y$useContext} from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $d94604d52c3e3feb$export$c7e742effb1c51e2 = (0, $3fe4y$react).createContext({});
function $d94604d52c3e3feb$export$21c7ab35b39f78ec() {
    return (0, $3fe4y$useContext)($d94604d52c3e3feb$export$c7e742effb1c51e2);
}
const $d94604d52c3e3feb$export$8d97fe02339fc0e3 = (0, $3fe4y$react).createContext(undefined);
function $d94604d52c3e3feb$export$dc2161044aa0b36d() {
    return (0, $3fe4y$useContext)($d94604d52c3e3feb$export$8d97fe02339fc0e3);
}
const $d94604d52c3e3feb$export$24aad8519b95b41b = (0, $3fe4y$react).createContext(undefined);
function $d94604d52c3e3feb$export$efa3856fc0e85e7f() {
    return (0, $3fe4y$useContext)($d94604d52c3e3feb$export$24aad8519b95b41b);
}


export {$d94604d52c3e3feb$export$c7e742effb1c51e2 as MenuContext, $d94604d52c3e3feb$export$21c7ab35b39f78ec as useMenuContext, $d94604d52c3e3feb$export$8d97fe02339fc0e3 as SubmenuTriggerContext, $d94604d52c3e3feb$export$dc2161044aa0b36d as useSubmenuTriggerContext, $d94604d52c3e3feb$export$24aad8519b95b41b as MenuStateContext, $d94604d52c3e3feb$export$efa3856fc0e85e7f as useMenuStateContext};
//# sourceMappingURL=context.module.js.map
